 <template>
    <section class="content" style="position:relative;">

    </section>
</template>
    
<script>
import {
    USER_ROLES
} from "../../../config";
import {
    Event
} from "vue-tables-2";
import moment from "moment";
import {
    mapState
} from "vuex";
import {
    formService,
    primarytripService
} from "../../../services";
import dateFormatter from "../../utilities/dateFormate";
import {
    fa
} from "faker/lib/locales";
export default {
    name: "reportsView",
    data() {
        return {
            disabledAfter: null,
            show: false,
            showw: false,
            page: null,
            limit: null,
            loading: null,
            // wardReportTable: null,
            parameters: {},
            noResult: true,
            endLocForDateFilter: "",
            isGenerateReport:false,
            formstate: {},
            wardReport:{
                wardId:"",
                date:""
            },
            wardList:[],
            columns: [
                "wardName",
                "date",
                "generatedAt",
                "generatedBy",
                "action",
            ],
            options: {
                highlightMatches: true,
                sortable: [],
                headings: {
                    wardName: "ward Name",
                    date: "Date",
                    generatedAt: "Generated At",
                    generatedBy: "Generated By",
                    action: "Action",
                },
                templates: {
                    scheduleTime(row, query) {
                        return dateFormatter(query.scheduleTime);
                    },
                },
                perPage: 10,
                // sortable: [
                //     "wardName",
                //     "date",
                //     "generatedAt",
                //     "generatedBy",
                // ],
                requestFunction: (request) => {
                    this.parameters.page = request.page;
                    this.parameters.limit = request.limit;
                    // this.page = request.page;
                    // this.limit = request.limit;
                    // if (this.startDateIso && this.endDateIso) {
                    //     this.parameters.startDate = this.startDateIso;
                    //     this.parameters.endDate = this.endDateIso;
                    // } else {
                    //     delete this.parameters.startDate;
                    //     delete this.parameters.endDate;
                    // }

                    // if (request.orderBy) {
                    //     if (request.orderBy == "cityName") {
                    //         this.parameters.sortBy = "cityId.cityName";
                    //     } else if (request.orderBy == "areaName") {
                    //         this.parameters.sortBy = "caId.areaName";
                    //     } else if (request.orderBy == "divisionward") {
                    //         this.parameters.sortBy = "cdId.cdName";
                    //     } else if (request.orderBy == "endLocation") {
                    //         this.parameters.sortBy = "endLoc.plantName";
                    //     } else if (request.orderBy == "driver") {
                    //         this.parameters.sortBy = "driverId.firstName";
                    //     } else if (request.orderBy == "helper") {
                    //         this.parameters.sortBy = "helperId.firstName";
                    //     } else if (request.orderBy == "vehicle") {
                    //         this.parameters.sortBy = "vehicleId.vNumber";
                    //     } else if (request.orderBy == "status") {
                    //         this.parameters.sortBy = "tripStatus";
                    //     } else if (request.orderBy == "waste") {
                    //         this.parameters.sortBy = "totalWeight";
                    //     } else {
                    //         this.parameters.sortBy = request.orderBy;
                    //     }
                    //     if (request.ascending == 1) {
                    //         this.parameters.sortOrder = "asc";
                    //     } else {
                    //         this.parameters.sortOrder = "dsc";
                    //     }
                    // }

                    // this.loading = true;
                    return primarytripService.getList(this.parameters).catch((error) => {
                        console.error("trip.requestFunction-error:", error);
                        this.$snotify.error("Get Trip", "Error!");
                    });
                },
                responseAdapter: (response) => {
                    this.loading = false;
                    let dataResp = [];
                    // response.data.primaryTripData.forEach((element) => {
                    //     let finalData = element;
                    //     finalData["wardName"] = element.wardName ? element.wardName : '--';
                    //     dataResp.push(finalData);
                    // });
                    return {
                        data: [],
                        count: 0,
                    };
                },
                uniqueKey: "_id",
            },
        };
    },
    computed: {
        addButtonClass() {
            if (this.primaryTripTable) {
                return this.primaryTripTable.count > this.primaryTripTable.limit ||
                    this.primaryTripTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        fieldClassName: formService.fieldClassName,
        gotoReportGeneration(){
            this.isGenerateReport =true
        },
        generateReport(){
            console.log('ssssss',this.wardReport)
        },
        onModalClose(){
            this.isGenerateReport = false;
        },
        // clearFilter() {
        //     this.startDateIso = "";
        //     this.endDateIso = "";
        //     this.filters = {
        //         city: "",
        //         startLocation: "",
        //         endLocation: "",
        //     };
        //     this.date = {
        //         startDate: "",
        //         endDate: "",
        //     };
        //     this.parameters.cityIds = "";
        //     this.parameters.startLoc = "";
        //     this.parameters.endLoc = "";
        //     this.startLocationList = [];
        //     this.endLocationList = [];
        //     this.$refs.primaryTripTable.refresh();
        // },

        clearStatus() {
            delete this.parameters["status"];
            this.statusValue = "";
            this.$refs.primaryTripTable.refresh();
        },
        // UpdateDestination(row) {
        //     if (row.status == "ongoing") {
        //         this.$router.push({
        //             name: "UpdateDestination",
        //             params: {
        //                 _id: row._id,
        //             },
        //             props: row,
        //         });
        //     }
        // },
        action(row) {
            this.$router.replace({
                name: "viewPrimaryTrip",
                params: {
                    _id: row._id,
                },
                props: row,
            });
        },
        onLoaded() {
            this.primaryTripTable = this.$refs.primaryTripTable;
        },

        // getCityList() {
        //     const params = {};
        //     this.cityList = [];
        //     let cities = [];
        //     this.$cityRepository
        //         .collectionCitysList(params)
        //         .then((res) => {
        //             this.loading = false;
        //             res.data.response.forEach((element) => {
        //                 if (element.status === true) {
        //                     cities.push({
        //                         name: element.cityName.length > 20 ?
        //                             element.cityName.slice(0, 20) + "..." :
        //                             element.cityName,
        //                         value: element._id,
        //                     });
        //                 }
        //             });
        //             cities.sort((item1, item2) => {
        //                 return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
        //             });
        //             this.cityList = cities;
        //         })
        //         .catch((error) => {
        //             this.loading = false;
        //             console.error("cities.requestFunction-error:", error);
        //             this.$snotify.error("Get cities list failed", "Error!");
        //         });
        // },
        viewReport(data){

        },
        downloadReport(data){

        },
    },
    mounted() {
        // if (this.$store.state.auth.user.role.key === "superAdmin") {
        //     this.options.sortable.push("cityName");
        // }
    },

    created(){

        let html = this.$route

        console.log('html>>>>>>>>>> ',html)

    }

};
</script>
    
<style scoped>
.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 225px;
    margin-left: 250px;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.inline {
    background-color: rgba(255, 132, 78);
    color: white;
}

.addnew {
    background-image: linear-gradient(to right,
            rgba(38, 153, 251),
            rgba(146, 205, 255));
    color: white;
}

.main_select_wrp_relative .modal-dialog {
    width: 50% !important;
}

.main_select_wrp_relative {
    position: absolute;
    right: 30%;
    top: 25px;
}

.filter_wrpp button svg {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.filter_wrpp button {
    display: flex;
    align-items: center;
    margin-right: 5px;
}

.filter_wrpp button:hover {
    background: #35A2FE;
    color: #fff;
}

.main_select_wrp_relative+.add-item {
    display: flex;
}

.select_date_wrp .datedrop_boxs {
    position: static;
    width: 100%;
    padding: 0px;
    box-shadow: none;
    border: transparent;
}

.select_date_wrp {
    margin-top: 20px;
}

.select_date_wrp .datedrop_boxs_wrp {
    float: initial;
    background: transparent;
    margin-right: 0;
}

/* .dates_left label {
    color: #000
} */

.dates_left {
    flex: 0 0 32.5%;
    margin-right: 10px;
}

.clearButton {
    margin-right: 33px;
    opacity: 0.8;
    color: blue;
    text-decoration: underline;
    font-size: large;
}

.filter-wrap .multiselected{
    min-width: 50%;
}

.form-modal-report{
    background: #fff;
}

.report .generate_report_pop .form-modal-report {
    width: 40%;
    height: 30%;
    padding: 24px 15px;
}
</style>
    


// WEBPACK FOOTER //
// reportView.vue?fabf1260